var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#96F9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.94 11.854H12.043a2.853 2.853 0 0 0-2.85 2.85v13.298a2.853 2.853 0 0 0 2.85 2.85h1.313l1.637 3.275a.949.949 0 0 0 1.321.4l6.43-3.675h10.198a2.853 2.853 0 0 0 2.85-2.85V14.703a2.853 2.853 0 0 0-2.85-2.85zm-1.9 9.499H13.943a.95.95 0 0 1 0-1.9h17.099a.95.95 0 0 1 0 1.9zm0-3.8H13.943a.95.95 0 0 1 0-1.9h17.099a.95.95 0 0 1 0 1.9z",
    fill: "#17CADC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeReviews);
export default __webpack_public_path__ + "static/media/homeReviews.98a97344d9d7799e2c60bcbf3c294d8b.svg";
export { ForwardRef as ReactComponent };